// ===== LINE Seller Popup =====

export function initLinePopup() {
  var SHOW_DELAY = 10000;

  var backdrop  = document.getElementById('line-popup-backdrop');
  var card      = document.getElementById('line-popup-card');
  var colBtn    = document.getElementById('line-popup-collapse');
  var floatWrap = document.getElementById('lp-float-wrap');
  var whiteCard = document.getElementById('lp-white-card');

  if (!backdrop || !card) return;

  function showFloat() {
    if (floatWrap) floatWrap.classList.add('lp-visible');
  }

  function hideFloat() {
    if (!floatWrap) return;
    floatWrap.classList.remove('lp-visible');
  }

  function openPopup() {
    hideFloat();
    card.style.display = '';
    document.body.classList.add('lp-popup-open');
    backdrop.classList.add('lp-visible');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        card.classList.add('lp-open');
      });
    });
  }

  function collapsePopup() {
    backdrop.classList.remove('lp-visible');
    document.body.classList.remove('lp-popup-open');
    card.classList.remove('lp-open');
    card.classList.add('lp-collapsing');

    card.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'transform') return;
      card.removeEventListener('transitionend', handler);
      card.style.display = 'none';
      card.classList.remove('lp-collapsing');
      showFloat();
    });
  }

  if (colBtn)   colBtn.addEventListener('click', collapsePopup);
  if (backdrop) backdrop.addEventListener('click', collapsePopup);

  if (whiteCard) {
    whiteCard.addEventListener('click', openPopup);
    whiteCard.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') openPopup();
    });
  }

  setTimeout(openPopup, SHOW_DELAY);
}